import type {AttributesWorking} from '../types';
import type {IAttributeTemplate} from '../schema';

/**
 * Get attribute templates that will be effected by a lookup
 * @param attributeTemplate The attribute template being lookup up from
 * @param attributeTemplates The attribute templates that could be involved
 * @return Attribute templates effected
 */
export const getTemplatesEffectedByLookup = (
	attributeTemplate: IAttributeTemplate,
	attributeTemplates: IAttributeTemplate[],
) => {
	return attributeTemplate.keyDatasets.reduce<AttributesWorking>(
		(attributesWorking, id) => {
			return {
				...attributesWorking,
				...attributeTemplates.reduce<AttributesWorking>(
					(attributesWorking, attr) => {
						if (!attr.targetDatasets.includes(id)) return attributesWorking;
						return {
							...attributesWorking,
							[attr.attributeid]: true,
						};
					},
					{},
				),
			};
		},
		{
			// the template passed in will be considered part of this
			[attributeTemplate.attributeid]: true,
		},
	);
};

export default getTemplatesEffectedByLookup;
